module.exports = __webpack_public_path__ + "static/media/luxanna-lose.dd0a4a03.png";